import { LuMinus, LuPlus } from 'react-icons/lu';

import usePlusMinusNumberInput from './plus-minus-number-input.controller';

const ID = 'plus-minus-number-input';
export interface PlusMinusNumberInputProps {
    min?: number;
    max?: number;
    increment?: number;
    value: number;
    onChange: (value: number) => void;
}

const PlusMinusNumberInput = (props: PlusMinusNumberInputProps) => {
    const viewProps = usePlusMinusNumberInput(props);

    return (
        <div
            id={ID}
            className='inline-flex items-start justify-start gap-2 self-stretch'>
            <button
                disabled={viewProps.disabled.decrement}
                onClick={() => {
                    if (viewProps.disabled.decrement) props.onChange(props.value);
                    else viewProps.onClick(-viewProps.increment);
                }}
                className='bg-background-surface border-border-default text-brand-muted disabled:text-border-default inline-flex w-20 items-center justify-center gap-2 overflow-hidden rounded-xl border px-4 py-3'>
                <LuMinus className='size-4' />
                <div className='justify-start text-base font-medium'>{viewProps.increment}</div>
            </button>

            <div className='bg-background-surface border-border-default flex flex-1 items-center self-stretch rounded-xl border'>
                {viewProps.increment > 1 && (
                    <button
                        disabled={viewProps.disabled.min}
                        onClick={() => {
                            if (viewProps.disabled.min) props.onChange(props.value);
                            else viewProps.onClick(-1);
                        }}
                        className='border-border-default text-brand-muted disabled:text-border-default inline-flex h-full w-11 items-center justify-center border-r'>
                        <LuMinus className='size-4' />
                    </button>
                )}

                <div
                    className='inline-flex flex-1 items-center justify-center self-stretch px-4'
                    onClick={() => viewProps.setIsEditing((prev) => !prev)}>
                    {viewProps.isEditing ? (
                        <input
                            type='text'
                            inputMode='numeric'
                            pattern='[0-9]*'
                            value={viewProps.temporaryValue}
                            onChange={(e) => viewProps.onManualInput(e.target.value)}
                            onBlur={viewProps.submitManualInput}
                            autoFocus
                            className='text-foreground-default w-full bg-transparent text-center text-xl font-semibold outline-none'
                        />
                    ) : (
                        <div className='text-foreground-default text-xl font-semibold'>{props.value}</div>
                    )}
                </div>

                {viewProps.increment > 1 && (
                    <button
                        disabled={viewProps.disabled.plus}
                        onClick={() => {
                            if (viewProps.disabled.plus) props.onChange(props.value);
                            else viewProps.onClick(1);
                        }}
                        className='border-border-default text-brand-muted disabled:text-border-default inline-flex h-full w-11 items-center justify-center border-l'>
                        <LuPlus className='size-4' />
                    </button>
                )}
            </div>

            <button
                disabled={viewProps.disabled.increment}
                onClick={() => {
                    if (viewProps.disabled.increment) props.onChange(props.value);
                    else viewProps.onClick(viewProps.increment);
                }}
                className='bg-background-surface border-border-default text-brand-muted disabled:text-border-default inline-flex w-20 items-center justify-center gap-2 overflow-hidden rounded-xl border px-4 py-3'>
                <LuPlus className='size-4' />
                <div className='justify-start text-base font-medium'>{viewProps.increment}</div>
            </button>
        </div>
    );
};

export default PlusMinusNumberInput;
